import { jsx as _jsx } from "react/jsx-runtime";
import FormikCheckBox from './formik/FormikCheckBox';
export function CheckBoxCell(props) {
    const { name, ...otherProps } = props;
    return (_jsx(FormikCheckBox, { style: {
            container: { display: 'block', margin: '0 auto', width: 'fit-content' },
        }, name: name, ...otherProps }, name));
}
